module.exports = __webpack_public_path__ + "img/instructions_1.a0c5c172.png";